export default "__VITE_ASSET__DJZ2t3j7__"